function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Checkbox } from '../../Checkbox';
import { FieldTypes } from '../helper';
import styles from '@dtsl/css-data-table/dist/index.module.css';
function TableRowRenderer(props) {
  const {
    row,
    idx,
    columns,
    onRowSelect,
    selectedRows,
    checkboxSelection,
    rowRenderer: RowRenderer
  } = props;
  const onChange = _ref => {
    let {
      target: {
        checked
      }
    } = _ref;
    onRowSelect(checked, {
      row: row,
      id: row.id || idx
    });
  };
  return /*#__PURE__*/React.createElement("tr", {
    className: `${styles['row-data']} ${row.className || ''} ${selectedRows.filter(obj => obj.id === (row.id || idx)).length > 0 ? styles['row-selected'] : ''}`,
    style: row.styles || {}
  }, RowRenderer ? /*#__PURE__*/React.createElement(RowRenderer, {
    row: row,
    index: idx,
    columns: columns
  }) : columns.map((_ref2, i) => {
    let {
      field,
      type,
      width = field === FieldTypes.ACTION ? 150 : 100,
      showTitle = false,
      masterColumn = false,
      rowCellRenderer: RowCellRenderer,
      colStyles = {}
    } = _ref2;
    const rowCellClasses = classNames({
      [styles['row-cell']]: true,
      [styles['text-align-right']]: field === FieldTypes.ACTION && type !== 'number' || type === 'number',
      [styles['text-align-left']]: field !== FieldTypes.ACTION && type !== 'number'
    });
    let rowContent = /*#__PURE__*/React.createElement(React.Fragment, null, RowCellRenderer ? /*#__PURE__*/React.createElement(RowCellRenderer, {
      row: row,
      rowIndex: idx,
      headerCellIndex: i,
      headerCell: columns[i],
      columns: columns,
      rowCell: row[field]
    }) : /*#__PURE__*/React.createElement("div", _extends({
      className: styles['text-truncate']
    }, showTitle ? {
      title: row[field]
    } : {}), row[field]));
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: field
    }, checkboxSelection && masterColumn && /*#__PURE__*/React.createElement("td", {
      className: `${rowCellClasses} ${checkboxSelection && masterColumn ? styles['checkbox-selection-master-column'] : ''}`
    }, /*#__PURE__*/React.createElement(Checkbox, {
      variant: "positive",
      label: "",
      "aria-label": "Row data checkbox",
      checked: selectedRows.filter(obj => obj.id === (row.id || idx)).length > 0,
      disabled: false,
      onChange: onChange,
      identifier: 'sibCheckbox_' + idx
    })), /*#__PURE__*/React.createElement("td", {
      key: field,
      className: rowCellClasses,
      style: {
        flex: field === FieldTypes.ACTION ? null : `1 0 ${width}px`,
        width: width + 'px',
        minWidth: width + 'px',
        ...colStyles
      }
    }, rowContent));
  }));
}
TableRowRenderer.propTypes = {
  selectedRows: PropTypes.array.isRequired,
  checkboxSelection: PropTypes.bool.isRequired,
  onRowSelect: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  rowRenderer: PropTypes.func,
  row: PropTypes.object.isRequired,
  idx: PropTypes.number,
  isListing: PropTypes.bool
};
TableRowRenderer.defaultProps = {
  idx: 0,
  rowRenderer: null
};
export default TableRowRenderer;